import { ArrowIcon, ClearIcon } from "components/Icons";
import { CLEAR, translate } from "shared/translate";
import { useRouter } from "next/router";
import { useState } from "react";
import cx from "classnames";
import styles from "./SelectFilters.module.css";

export const SelectFilters = ({ filters, setValues, values }) => {
  const { locale } = useRouter();
  const [selectFocussedIndex, setSelectFocussedIndex] = useState();

  return (
    <div className={styles.container}>
      {filters
        .filter(({ options }) => Boolean(options.length))
        .map(({ label, value, options }, index) => (
          <div
            className={cx(styles.selectContainer, {
              [styles.focus]: selectFocussedIndex === index,
            })}
            key={value}
          >
            <div
              className={cx(styles.fakeSelect, {
                [styles.hasValue]: !!values[value],
              })}
            >
              {options.filter((option) => values[value] === option.value)[0]
                ?.label || label}
            </div>
            <ArrowIcon />

            <select
              aria-label={label}
              className={styles.select}
              onClick={() => setSelectFocussedIndex(null)}
              onBlur={() => setSelectFocussedIndex(null)}
              onChange={(e) =>
                setValues({ ...values, [value]: e.target.value })
              }
              onFocus={() => setSelectFocussedIndex(index)}
              value={values[value] || ""}
            >
              <option value="">{label}</option>
              {options.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        ))}
      {Object.values(values).length > 0 && (
        <button onClick={() => setValues({})} className={styles.clearButton}>
          <span className={styles.clearButtonInner}>
            <ClearIcon />
            <span>{translate(CLEAR, locale)}</span>
          </span>
        </button>
      )}
      <div className={styles.mobileSpacer} />
    </div>
  );
};
